import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

import { KorviuButtonComponent } from 'shared';

@Component({
  selector: 'app-promotion-threshold-warning-modal',
  imports: [KorviuButtonComponent, TranslatePipe],
  templateUrl: './promotion-threshold-warning-modal.component.html',
  styleUrl: './promotion-threshold-warning-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PromotionThresholdWarningModalComponent {
  readonly #modal = inject(NzModalRef);

  public close(): void {
    this.#modal.destroy();
  }

  public completeForm(): void {
    this.#modal.close({ completeForm: true });
  }
}
